import React from 'react';
import { LocalizedContent } from '../../data/siteContent';
import { Logo } from './Logo';
type Props = {
  content: LocalizedContent;
  className?: string;
  compact?: boolean;
  align?: 'left' | 'center';
  mobileHidden?: boolean;
};

// Repeated visual signature: the M&S name, crest and promise travel together.
// It deliberately scales up at desktop and UHD sizes so the brand stays legible in a cinematic frame.
export function BrandSignature({
  content,
  className = '',
  compact = false,
  align = 'left',
  mobileHidden = false
}: Props) {
  const alignment = align === 'center' ? 'justify-center text-center' : 'justify-start text-left';
  const display = mobileHidden ? 'hidden sm:flex' : 'flex';
  const crestSize = compact ? 'h-11 w-11 sm:h-12 sm:w-12 lg:h-16 lg:w-16 2xl:h-20 2xl:w-20' : 'h-14 w-14 sm:h-16 sm:w-16 lg:h-20 lg:w-20 2xl:h-24 2xl:w-24';
  const wordmarkSize = compact ? 'text-lg sm:text-xl lg:text-3xl 2xl:text-4xl' : 'text-xl sm:text-2xl lg:text-4xl 2xl:text-5xl';
  return <div className={`${display} items-center gap-3 sm:gap-4 lg:gap-5 2xl:gap-6 ${alignment} ${className}`} data-id="element-178" data-mp="lm4kxpuwg0cv">
      <Logo alt="M&S Travel" className={`${crestSize} shrink-0 rounded-full border border-[var(--ms-gold-soft)]/60 shadow-[0_16px_40px_-18px_rgba(0,0,0,0.95)]`} data-id="element-179" data-mp="pnyg5imbsc5n" />
      <div data-id="element-180" data-mp="zczw58svetjm">
        <p className={`${wordmarkSize} font-editorial leading-none tracking-tight text-[var(--ms-ivory)]`} data-id="element-181" data-mp="zdrrciik2p9d">
          M<span className="text-[var(--ms-gold-soft)]" data-id="element-182" data-mp="14b1fluu7kuvm">&amp;</span>S Travel
        </p>
        <p className="mt-1 text-[9px] font-medium uppercase tracking-[0.18em] text-[var(--ms-gold-soft)] sm:text-[10px] lg:mt-2 lg:text-xs lg:tracking-[0.21em] 2xl:text-sm" data-id="element-183" data-mp="199uu9ql8erxd">
          {content.tagline}
        </p>
      </div>
    </div>;
}